import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { SvgSuccess, ButtonText } from '@ntuctech/devex-tangram';
import styled from 'styled-components';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import Copy from '../icons/svg/Copy.svg';
import TosterComponent from '../Toster/TosterComponent';

export const StyledPromoCode = styled.div`
  font-weight: 600;
  font-size: 1rem;

  .promo-code-field {
    width: 100%;
    border: 1px solid #666666;
  }
  &[data-faded='true'] {
    background: #f2f2f2;
    border-radius: 0.25rem;
    .promo-code-field {
      border: none;
    }
    .promo-code-text {
      color: #cccccc;
    }
  }
  max-width: 100%;
  flex: 1;
  padding: 12px 0 40px;

  ${SCREEN_SIZE.From.Tablet} {
    color: white;
  }

  @media print {
    color: #666666;
  }
`;
export const PromoCodeField = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: left;
  border-radius: 0.25rem;
  width: 19.5rem;
  margin: 1rem 0 1.5rem;
  padding: 0.5rem 1rem;
`;
export const PromoCodeText = styled.div`
  line-height: 1.5;
  font-weight: bold;
  color: #333;
  width: 14rem;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const CopyButton = styled.button`
  background: none;
  cursor: pointer;
  font-weight: bold;
  line-height: 1.5;
  margin: ${(props) => (props.isMobile ? '0 0.2rem' : 0)};
  padding: 0;
  margin-right: 0.3rem;
  border: none;
  color: #1454b8;
`;

const StyledDivImg = styled.div`
  padding: ${(props) => (props.copied ? '8px 2rem' : '0')};
  background: ${(props) => (props.copied ? '#E8F0FD' : '')};
  min-height: ${(props) => (props.copied ? '3rem' : '')};
  border: ${(props) => (props.copied ? '0.0625rem solid transparent' : '')};
  border-radius: ${(props) => (props.copied ? '0.25rem' : '')};
  text-align: center;
  img {
    position: relative;
    width: 16px;
    height: 16px;
    top: 3px !important;
    margin-right: 6px;
  }
  span: {
    font-weight: 14px;
  }
`;

const CopyPromoCode = (props) => {
  const { code, hasDepleted, hasExpired, isCopied = false } = props;
  const [copied, setCopied] = React.useState(isCopied);
  const enableCopyIfValid = !hasDepleted && !hasExpired;

  return (
    <StyledPromoCode data-faded={hasDepleted || hasExpired}>
      <TosterComponent
        type="success"
        icon={<SvgSuccess />}
        message="Voucher code copied!"
        isError={copied}
      />
      {enableCopyIfValid && (
        <CopyToClipboard
          data-testid="copy-promo-code"
          onCopy={() => {
            setCopied(true);
          }}
          text={code}
        >
          <ButtonText data-testid="copy-btn" size="m">
            <StyledDivImg copied={copied}>
              <img src={Copy.src} alt={Copy} />
              <span>Copy Code</span>
            </StyledDivImg>
          </ButtonText>
        </CopyToClipboard>
      )}
    </StyledPromoCode>
  );
};

export default CopyPromoCode;
